module.exports = __webpack_public_path__ + "static/media/slide-2.f79bed9b.jpg";